import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupsIcon from "@mui/icons-material/Groups";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

const adminDashboardNav = [
  {
    key: "overview",
    label: "Overview",
    description: "Pipeline and totals",
    icon: <DashboardIcon fontSize="small" />,
  },
  {
    key: "operations",
    label: "Operations",
    description: "Requests, contracts, timesheets",
    icon: <WorkOutlineIcon fontSize="small" />,
  },
  {
    key: "people",
    label: "People",
    description: "Contractor reviews",
    icon: <GroupsIcon fontSize="small" />,
  },
  {
    key: "finance",
    label: "Finance",
    description: "Contractor invoices",
    icon: <ReceiptLongIcon fontSize="small" />,
  },
];

export default adminDashboardNav;
